import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/cortena.webp';
import screenshot_target from '../../../images/letterfunnel/brunopellicci.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Bruno Pellicci"
      firstname="Bruno"
      companyname="Cortena"
      competition="Vic.ai en Candis"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/brunopellicci.js